export const autocomplete = {
  root: {
    filledHoverBackground: '{primary.100}',
  },
  dropdown: {
    // width: '2.5rem',
    color: '{neutral.400}',
  },
  colorScheme: {
    light: {
      borderColor: '{neutral.200}',
      hoverBorderColor: '{neutral.400}',
      focusBorderColor: '{neutral.400}',
      placeholderColor: '{inputtext.placeholder.color}',
      dropdown: {
        background: '{surface.100}',
        color: 'black',
        borderColor: '{neutral.200}',
        hoverBackground: '{surface.100}',
        hoverBorderColor: '{neutral.200}',
        hoverColor: 'black',
      },
    },
    dark: {
      background: '#333643',
      color: 'white',
      borderColor: '#5B5F69',
      placeholderColor: '{inputtext.placeholder.color}',
      disabled: {
        // background: '{surface.400}',
        color: '#f0f1f471',
      },
      dropdown: {
        background: '#333643',
        color: 'white',
        borderColor: '#5B5F69',
        hoverBackground: '#333643',
        hoverBorderColor: '#5B5F69',
      },
      option: {
        color: 'white',
        selectedBackground: '{primary.400}',
        focus: {
          background: '#555B6E',
          selectedBackground: '{primary.400}',
          selectedFocusBackground: '{primary.300}',
          color: 'white',
        },
        selected: {
          color: 'white',
          focus: {
            background: '{primary.300}',
            color: 'white',
          },
        },
      },
      overlay: {
        background: '{surface.600}',
        color: 'white',
        borderColor: '#5B5F69',
        list: 'white',
      },
    },
  },
};
